import { useMemo } from 'react'
import PropTypes from 'prop-types'
import { H2, P3 } from '@moneymade/moneymade-ui'
import moment from 'moment'

import { toMoneyFormat } from 'utils'
import FlashingBlock from 'components/ui/FlashingBlock/FlashingBlock'
import styles from './Header.module.scss'

const Header = ({
  pricesData: { slugFirst, slugSecond },
  prevSumReturn: { prevSumReturnSlug1, prevSumReturnSlug2 },
  graphFocus,
  slugLabel,
  syncDate
}) => {
  const value = useMemo(() => {
    const slugValue = toMoneyFormat((graphFocus ? prevSumReturnSlug2 : slugSecond)?.toFixed(1) || 0)
    if (slugValue && slugValue !== 'NaN') return slugValue
    return 0
  }, [graphFocus, prevSumReturnSlug2, slugSecond])

  const date = useMemo(() => moment.utc(syncDate || '').fromNow(), [syncDate])

  return (
    <div className={styles.Header}>
      <FlashingBlock>
        <H2 className={styles.Title} type="heading" weight="bold">
          {toMoneyFormat((graphFocus ? prevSumReturnSlug1 : slugFirst)?.toFixed(1) || 0)}%{' '}
        </H2>
      </FlashingBlock>

      <div className={styles.SubHeader}>
        <P3 weight="light">
          Versus {slugLabel}
          <FlashingBlock className={styles.VersusVal}> {value}%</FlashingBlock>
        </P3>

        {syncDate && <P3 className={styles.Dot}>•</P3>}

        {syncDate && (
          <P3 weight="light" className={styles.Date}>
            {date}
          </P3>
        )}
      </div>
    </div>
  )
}

Header.propTypes = {
  pricesData: PropTypes.shape({
    slugFirst: PropTypes.number,
    slugSecond: PropTypes.number
  }),
  prevSumReturn: PropTypes.shape({
    prevSumReturnSlug1: PropTypes.number,
    prevSumReturnSlug2: PropTypes.number
  }),
  graphFocus: PropTypes.bool,
  slugLabel: PropTypes.string,
  syncDate: PropTypes.string
}

Header.defaultProps = {
  pricesData: {
    slugFirst: 0,
    slugSecond: 0
  },
  prevSumReturn: {
    prevSumReturnSlug1: 0,
    prevSumReturnSlug2: 0
  },
  graphFocus: false,
  slugLabel: '',
  syncDate: ''
}

export default Header
